(function () {
  'use strict';

  var SELECTORS = {
    slider: '[data-eth-home-slider]',
    slide: '[data-eth-home-slide]',
    dot: '[data-eth-home-slide-to]',
    previous: '[data-eth-home-previous]',
    next: '[data-eth-home-next]'
  };

  function initSlider(slider) {
    if (slider.ethHomeSlider) {
      return slider.ethHomeSlider;
    }

    var slides = Array.prototype.slice.call(slider.querySelectorAll(SELECTORS.slide));
    var dots = Array.prototype.slice.call(slider.querySelectorAll(SELECTORS.dot));
    var previous = slider.querySelector(SELECTORS.previous);
    var next = slider.querySelector(SELECTORS.next);
    var autoplay = slider.dataset.autoplay === 'true';
    var delay = Math.max(3000, Number(slider.dataset.autoplaySeconds || 7) * 1000);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;
    var touchStartX = null;
    var listeners = [];

    function listen(target, eventName, handler, options) {
      if (!target) {
        return;
      }

      target.addEventListener(eventName, handler, options);
      listeners.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function show(index, focusControl) {
      if (!slides.length) {
        return;
      }

      current = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === current;
        dot.setAttribute('aria-current', active ? 'true' : 'false');

        if (focusControl && active) {
          dot.focus();
        }
      });
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();

      if (autoplay && !reducedMotion && !document.hidden && slides.length > 1) {
        timer = window.setInterval(function () {
          show(current + 1, false);
        }, delay);
      }
    }

    function restart() {
      start();
    }

    dots.forEach(function (dot) {
      listen(dot, 'click', function () {
        show(Number(dot.dataset.ethHomeSlideTo || 0), false);
        restart();
      });
    });

    listen(previous, 'click', function () {
      show(current - 1, false);
      restart();
    });

    listen(next, 'click', function () {
      show(current + 1, false);
      restart();
    });

    listen(slider, 'keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        show(current - 1, true);
        restart();
      } else if (event.key === 'ArrowRight') {
        show(current + 1, true);
        restart();
      }
    });

    listen(slider, 'mouseenter', stop);
    listen(slider, 'mouseleave', start);
    listen(slider, 'focusin', stop);
    listen(slider, 'focusout', start);
    listen(document, 'visibilitychange', start);

    listen(slider, 'touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
      stop();
    }, { passive: true });

    listen(slider, 'touchend', function (event) {
      var distance;

      if (touchStartX === null) {
        return;
      }

      distance = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;

      if (Math.abs(distance) >= 45) {
        show(current + (distance < 0 ? 1 : -1), false);
      }

      start();
    }, { passive: true });

    slider.ethHomeSlider = {
      show: show,
      start: start,
      stop: stop,
      destroy: function () {
        stop();
        listeners.forEach(function (removeListener) {
          removeListener();
        });
        listeners = [];
        delete slider.ethHomeSlider;
      }
    };

    show(0, false);
    start();
    return slider.ethHomeSlider;
  }

  function init(root) {
    var scope = root || document;
    var sliders = [];

    if (scope.matches && scope.matches(SELECTORS.slider)) {
      sliders.push(scope);
    }

    sliders = sliders.concat(Array.prototype.slice.call(scope.querySelectorAll(SELECTORS.slider)));
    sliders.forEach(initSlider);
  }

  function destroy(root) {
    var sliders = [];

    if (root.matches && root.matches(SELECTORS.slider)) {
      sliders.push(root);
    }

    sliders = sliders.concat(Array.prototype.slice.call(root.querySelectorAll(SELECTORS.slider)));
    sliders.forEach(function (slider) {
      if (slider.ethHomeSlider) {
        slider.ethHomeSlider.destroy();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.matches(SELECTORS.slide)
      ? event.target
      : event.target.closest(SELECTORS.slide);
    var slider;
    var slides;

    if (!slide) {
      return;
    }

    slider = slide.closest(SELECTORS.slider);
    slides = Array.prototype.slice.call(slider.querySelectorAll(SELECTORS.slide));
    initSlider(slider).stop();
    slider.ethHomeSlider.show(slides.indexOf(slide), false);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var slider = event.target.closest(SELECTORS.slider);

    if (slider && slider.ethHomeSlider) {
      slider.ethHomeSlider.start();
    }
  });
}());
